import styled from '@emotion/styled';
export const GamingWidgetButtonWrapper = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const GamingWidgetStyledButton = styled.a `
  width: 100px;
  padding: 2px;
  min-width: 60px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: rgb(230, 230, 250);
  background-color: rgb(60, 95, 200);
  border-radius: 5px;
  text-decoration: none;
  font-size: 14px;
  overflow: hidden;
  text-align: center;
  &:hover :active :visited {
    text-decoration: none;
  }
`;
